function isGroupOption(option) {
    return 'options' in option;
}
function isPlainOption(option) {
    return 'value' in option;
}
/**
 * Searches for a matching option in a list of combobox options, including nested group options.
 *
 * Recursively traverses the provided options array to find a `ComboboxPlainOption` whose `value`
 * matches the specified `value`. If a group option is encountered, its nested options are searched as well.
 *
 * @param value - The value to match against the options' values.
 * @param options - An array of `ComboboxOption` objects, which may include group and plain options.
 * @returns The matching `ComboboxPlainOption` if found; otherwise, `null`.
 */
function getMatchingOption(value, options) {
    // Check each option in the array
    for (const option of options) {
        // If this is a group option, recursively search its nested options
        if (isGroupOption(option)) {
            const matchInGroup = getMatchingOption(value, option.options);
            if (matchInGroup) {
                return matchInGroup;
            }
        }
        // If this is a plain option, check if its value matches
        else if (option.value === value) {
            return option;
        }
    }
    // Return null if no matching option was found
    return null;
}

export { getMatchingOption, isGroupOption, isPlainOption };
//# sourceMappingURL=helper.js.map
